<iframe #frame title="Growth Localiza" src="https://app.powerbi.com/view?r=eyJrIjoiYzQzMWVlYzctOTE1ZS00YWQxLWJlMGYtMzdhN2JhNjlhZjNiIiwidCI6ImZkOTliM2EzLWUzODctNGE1MC05NTRhLTUzMDc5NGY5NWYwMCJ9" allowFullScreen="true"></iframe>
